module.exports = __webpack_public_path__ + "static/headlinecaps-dont-158a265283c5402a525ce56d83d1a07c.png";